import { inject, Injectable, OnDestroy } from '@angular/core';
import { BehaviorSubject, forkJoin, Observable, Subject, takeUntil, tap } from 'rxjs';
import BlockModel from '../models/email-template/block-model.interface';
import { TemporaryMedia } from '../models/email-template/temporary-media.interface';
import { TemplateService } from './template.service';
import { GlobalTemplateService } from './global-template.service';

@Injectable({ providedIn: 'root' })
export class BlockManagementService {

  /**
     * Reorders the `count` property for each block in `selectedBlocks` based on their name.
     *
     * For each unique block name, finds all blocks with that name and assigns their `count`
     * property sequentially starting from 1. This ensures that blocks with the same name
     * have unique, consecutive `count` values.
     *
     */
  reorderCount(selectedBlocks: BlockModel[]) {
    // Get all block names
    const allBlockNames: string[] = [];
    selectedBlocks.map((block) => {
      const foundBlock = allBlockNames.find(
        (blockName) => blockName === block.name
      );
      if (!foundBlock) {
        allBlockNames.push(block.name);
      }
    });

    // Reorder the counts
    allBlockNames.map((blockName) => {
      const blocksToReorder = selectedBlocks.filter(
        (block) => block.name === blockName
      );
      blocksToReorder.forEach((block, index) => {
        block.count = index + 1;
      });
    });

    return selectedBlocks;
  }
}
